export default function () {
    const $ = window.jQuery;

    const form = $('#activecampaign-for-woocommerce-options-form');
    const button = $('#activecampaign-update-api-button');
    const nonceVal = $('#activecampaign_for_woocommerce_settings_nonce_field');

    let data = {};
    data.api_url = form.find('input[name="api_url"]').val();
    data.api_key = form.find('input[name="api_key"]').val();
    data.activecampaign_for_woocommerce_settings_nonce_field = nonceVal.attr('value');
    data.action = 'api_test';

    let url = button.attr('value');
    let type = 'POST';

    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            type: type,
            data:data
        }).done(response => {
            resolve(response.data);
        }).fail(response => {
            reject(response.responseJSON.data)
        });
    })
}


// WEBPACK FOOTER //
// ./admin/src/js/scripts/ajaxApiTest.js